import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import '../css/debtNotice.css';

const InformarDebitos = () => {
    const [ccs, setCCs] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitInformarDebitos (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            ccs
        });
        try {
            const response = await fetchFlask('informarDebitos', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setCCs('');
            }
        } finally {
            setIsSubmit(false);
        }
    };

    const ccsList = ccs
        .split(/[\s,;]+/)
        .map((cc) => cc.trim())
        .filter(Boolean);
    const completedFields = [ccsList.length > 0].filter(Boolean).length;

    return (
        <Box className='mainBox debt-notice-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Informar Débitos
            </PageHeader>

            <form action='' method='POST' id='formInformarDebitos' onSubmit={submitInformarDebitos} className='debt-notice-layout'>
                <Box className='debt-notice-workspace'>
                    <Box className='debt-notice-intro'>
                        <Box>
                            <h2>Notificação de débitos Neoenergia</h2>
                        </Box>
                        <p>
                            Cole a lista de contas contrato que receberão a comunicação por WhatsApp sobre débitos junto à distribuidora.
                        </p>
                    </Box>

                    <Box className='debt-notice-panel'>
                        <Box className='debt-notice-section-heading'>
                            <ListAltRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Contas contrato do lote</strong>
                            </Box>
                        </Box>

                        <Box className='debt-notice-input-strip'>
                            <ReportProblemRoundedIcon />
                            <TextField
                                label='Conta contratos'
                                id='ccs'
                                required
                                multiline
                                minRows={7}
                                maxRows={14}
                                value={ccs}
                                onChange={(e) => setCCs(e.target.value)}
                                placeholder='Uma CC por linha, ou separadas por vírgula'
                            />
                        </Box>
                    </Box>

                    <Box className='debt-notice-channel'>
                        <WhatsAppIcon />
                        <Box>
                            <strong>Envio via WhatsApp</strong>
                            <span>A lista será enviada para o processo que notifica os clientes sobre pendências junto à Neoenergia.</span>
                        </Box>
                    </Box>
                </Box>

                <Box className='debt-notice-summary'>
                    <Box className='debt-notice-summary-header'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão do lote</strong>
                        </Box>
                    </Box>

                    <Box className='debt-notice-summary-list'>
                        <Box>
                            <span>Contas contrato</span>
                            <strong className={ccsList.length === 0 ? 'is-empty' : undefined}>
                                {ccsList.length === 0 ? 'Não informadas' : `${ccsList.length} identificada${ccsList.length === 1 ? '' : 's'}`}
                            </strong>
                        </Box>
                        <Box>
                            <span>Canal</span>
                            <strong>WhatsApp</strong>
                        </Box>
                        <Box>
                            <span>Referência</span>
                            <strong>Débitos Neoenergia</strong>
                        </Box>
                    </Box>

                    <Box className='debt-notice-attention'>
                        <ReportProblemRoundedIcon />
                        <p>
                            Revise a lista antes de enviar. Todas as contas contrato informadas serão consideradas no lote de notificação.
                        </p>
                    </Box>

                    <Box className='debt-notice-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                        Enviar Notificações
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default InformarDebitos;
